module.exports = __webpack_public_path__ + "static/media/exukonline-shipping-port.d74b746b.jpg";